module.exports = __webpack_public_path__ + "circle-ir.d3255f94.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/media/circle-ir.png
// module id = 2561
// module chunks = 0